<template>
    <div class="honour-frame">
        <a class="anchor" id="dotRyzz"></a>
        <div class="home-title-bt">
            <div class="home-t-bg">Qualification</div>
            <p>荣誉资质</p>
        </div>
        <div class="honour-main" ref="swiperF">
            <div class="honour-min">
                <div class="slideshow">
                    <div class="swiper-container">
                        <div class="swiper-wrapper">
                            <div v-for="(item, i) in imgList" :key="i" class="swiper-slide" :style="{width:item.width+'px'}">
                                <img :src="item.img" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--<p class="honour-txt">{{imgList[mySwiper.realIndex].name}}</p>-->
            <div class="auction-banner-button">
                <div class="swiper-button-prev swiper-button-white"></div>
                <div class="swiper-button-next swiper-button-white"></div>
            </div>
        </div>
        <div class="play-frame" v-show="showBol" @click="close()">
            <div class="play-video" style="width: 900px;margin-left: -500px" v-if="realIndexWidth" @click.stop="btnStop()">
                <div class="play-close" @click="close">
                    <img src="../../../assets/images/join/close.png" alt="">
                </div>
                <img class="photo-show" style="width: 900px;" :src="url" alt="">
            </div>
            <div class="play-video" v-else @click.stop="btnStop()">
                <div class="play-close" @click="close">
                    <img src="../../../assets/images/join/close.png" alt="">
                </div>
                <img class="photo-show" :src="url" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper'
    import 'swiper/dist/css/swiper.css';
    export default {
        name: "honour",
        data() {
            return {
                imgList: [
                    {
                        img: require("../../../assets/images/index/ccie/zs20.jpg"),
                        width: '470',
                        name: '高新技术企业证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs17.jpg"),
                        name: '增值电信业务经营许可证',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs18.jpg"),
                        width: '470',
                        name: '拍卖经营批准证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs19.jpg"),
                        width: '470',
                        name: '发明专利证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs1.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs2.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs3.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs4.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs5.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs6.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs7.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs8.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs9.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs10.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs11.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs12.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs13.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs14.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs15.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                    {
                        img: require("../../../assets/images/index/ccie/zs16.jpg"),
                        name: '计算机软件著作登记权证书',
                    },
                ],
                mySwiper: {
                    realIndex: 0,
                },
                showBol: false,
                url: '',
                realIndexWidth: '',
            };
        },
        methods: {
            close(){
                this.mySwiper.autoplay.start()
                this.showBol = false
            },
            btnStop(){
                return false
            },
            isElementNotInViewport: (el) => {
                if (el) {
                    let rect = el.getBoundingClientRect();
                    return (
                        rect.top >=
                        (window.innerHeight || document.documentElement.clientHeight) ||
                        rect.bottom <= 0
                    );
                }
            },
            handleScrollbox2() {
                if(!this.isElementNotInViewport(this.$refs.swiperF)){
                    this.mySwiper.autoplay.start()
                }else{
                    this.mySwiper.autoplay.stop()
                }
            },
            handleClickSlide(vm) {
                let index = vm.clickedIndex - vm.activeIndex + vm.realIndex === 20 ? 0 : vm.clickedIndex - vm.activeIndex + vm.realIndex;
                // 我得到的index就是点击的item在实际数组中的下标index
                if(this.imgList[index]){
                    if(this.imgList[index].img){
                        this.url = this.imgList[index].img;
                        this.realIndexWidth = this.imgList[index].width
                        this.showBol = true;
                        this.mySwiper.autoplay.stop()
                    }
                }
            }
        },
        mounted() {
            let that = this;
            this.$nextTick(() => {
                window.addEventListener('scroll', this.handleScrollbox2, true)
                this.mySwiper = new Swiper(".slideshow .swiper-container", {
                    slidesPerView: "auto",
                    autoplay: { disableOnInteraction: false,delay: 5000 },
                    loop:true,
                    spaceBetween: 30,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    on: {
                        click:function(){
                            that.handleClickSlide(this);
                        }
                    },
                });
            });

        },

        beforeDestroy() {
            window.removeEventListener('scroll', this.handleScrollbox2, true)
        },

    }
</script>

<style scoped lang="scss">
    .honour-frame{
        position: relative;
        user-select: none;
        .anchor{
            position: absolute;
            opacity: 0;
            top: -200px;
        }
        .honour-main{
            width: 1200px;
            margin: 0 auto;
            padding: 90px 0 140px;
            overflow: hidden;
            .honour-min{
                position: relative;
                height: 400px;
            }
            .honour-txt{
                font-size: 18px;
                font-family: 'SourceHanSansCN-Regular';
                color: #333333;
                line-height: 30px;
                text-align: center;
                padding-top: 40px;
            }
        }
        .play-frame{
            position: fixed;
            z-index: 1000;
            background-color: rgba(0,0,0,0.6);
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            .play-video{
                position: absolute;
                left: 50%;
                top: 50%;
                width: 500px;
                height: 634px;
                margin-left: -250px;
                margin-top: -317px;
                .play-close{
                    position: absolute;
                    width: 30px;
                    height: 30px;
                    overflow: hidden;
                    cursor: pointer;
                    right: -15px;
                    top: -15px;
                    z-index: 1;
                    img{
                        width: 30px;
                        height: 30px;
                        display: block;
                    }
                }
            }
            .photo-show{
                overflow: hidden;
                width: 500px;
                height: 634px;
                display: block;
            }
        }
    }
    .auction-banner-button{
        position: absolute;
        width: 1360px;
        left: -80px;
        top: 320px;
    }
    .slideshow {
        width: 1200px;
        overflow: hidden;
        height: 400px;
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -600px;
        .swiper-wrapper{
            height: 400px;
            img{
                width: 100%;
                height: 100%;
                -webkit-box-reflect: below 0 -webkit-linear-gradient(bottom, rgba(255, 255, 255, 0.6) 0%, transparent 30%, transparent 100%);
            }
        }
        .swiper-slide {
            height: 300px;
            padding-bottom: 100px;
            width: 235px;
            box-sizing: content-box;
            transform:translate3d(0,0,0);
        }

    }
    .swiper-container{
        transform:translate3d(0,0,0);
    }

    .swiper-button-prev, .swiper-button-next{
        width: 40px;
        height: 40px;
        background-color: rgba(179, 179, 179,0.6);
        background-size: 20px 20px;
        position: absolute;
        top: 50%;
        margin-top: -22px;
        z-index: 10;
        cursor: pointer;
        background-position: 50%;
        background-repeat: no-repeat;
    }
    .swiper-button-prev{
        left: 15px;
    }
    .swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after{
        font-size: 18px;
    }
    .swiper-button-next{
        right: 15px;
    }
    .swiper-button-prev:after, .swiper-container-rtl .swiper-button-prev:after{
        font-size: 18px;
    }
</style>
